import en from "./en.json";

export type Locale = typeof en;

/** `resolveJsonModule` types this, so a missing key is a compile error. */
export const t: Locale = en;

/**
 * Replaces each `%s` in order with the values given.
 *
 * `%s` counts are not checked by the compiler, so this is deliberately
 * defensive: a missing value leaves the placeholder visible rather than
 * printing "undefined", and extra values are ignored.
 */
export const fmt = (template: string, ...values: (string | number)[]): string => {
  let index = 0;
  return template.replace(/%s/g, () =>
    index < values.length ? String(values[index++]) : "%s",
  );
};
